'use client';

import { x } from '@xstyled/styled-components';
import { ChangeEvent } from 'react';

type Props = {
  ariaLabel: string;
  id: string;
  max: number;
  min: number;
  onChange: (value: number) => void;
  step: number;
  value: number;
};

// The global input[type=range] style (DesignSystemProvider) paints its yellow
// fill via background-size and relies on the input keeping it in sync with the
// current value. Inline style required: the global [type=range] selector
// outspecifies the xstyled backgroundSize prop's class.
export const RangeInput = ({ ariaLabel, id, max, min, onChange, step, value }: Props) => {
  const fillPct = ((value - min) * 100) / (max - min);

  return (
    <x.input
      aria-label={ariaLabel}
      id={id}
      max={max}
      min={min}
      onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(Number(event.target.value))}
      step={step}
      style={{ backgroundSize: `${fillPct}% 100%` }}
      type="range"
      value={value}
      w="100%"
    />
  );
};
